module.exports = __webpack_public_path__ + "uy.svg?011aeeb94af99b085cdc4c156a7e8174";